export function fixSVGClassListSupportForIE() {
  /* istanbul ignore next */
  if (!('classList' in SVGElement.prototype)) {
    Object.defineProperty(SVGElement.prototype, 'classList', {
      get() {
        return {
          contains: className => this.className.baseVal.split(' ').indexOf(className) !== -1,
        };
      },
    });
  }
}
